import DCFButtonToggleDialog from '@dcf/js/components/dcf-button-toggle-dialog.js';

export default class UNLButtonToggleDialog extends DCFButtonToggleDialog {

    constructor(buttonElement, options = {}) {
        super(buttonElement, options);
    }

}
